<template>
  <div>
    <a-spin :spinning="loading">
      <div class="neo-tabs-fees">
        <a-tabs :tabPosition="this.settings['isMobileView'] ? 'top' : 'top'" @change="handleStudentChange">
          <a-tab-pane
            v-for="student in data"
            :tab="`${student.first_name} ${student.last_name} (${student.student_code}) ${student.enrollment[0].school_class ? student.enrollment[0].school_class.name : ''} ${student.enrollment[0].section ? student.enrollment[0].section.name : ''}`"
            :key="student.id"
            :forceRender="true"
          >
            <neo-camera :data="student" @updated="handlePhotoUpdate" />
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-spin>
  </div>

</template>

<script>
import { mapState } from 'vuex'

import NeoCamera from './partials/NeoCamera'
export default {
  name: 'StudentPhotoUpload',
  props: ['data', 'loading', 'session'],
  components: {
    NeoCamera,
  },
  data: function() {
    return {
    }
  },
  computed: {
    ...mapState(['settings']),
  },
  methods: {
    handlePhotoUpdate() {
      this.$emit('updateTable')
    },
    handleStudentChange() {

    },
  },
}
</script>
